module.exports = __webpack_public_path__ + "img/clearing-house.7c50adce.webp";